import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { SidebarPolaris as PolarisProjectSidebarType } from './ui/index.tsx';

const LazyPolarisProjectSidebar = lazyAfterPaint<typeof PolarisProjectSidebarType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-polaris" */ './index').then((bundle) => {
		setPerformanceMarkLoadEnd();
		return bundle;
	});
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PolarisProjectSidebar = memo<Record<any, any>>(() => (
	<SidebarBoundary id="polarisProject">
		<LazyPolarisProjectSidebar />
	</SidebarBoundary>
));

PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';

export default PolarisProjectSidebar;
